import { useMutation } from "@tanstack/react-query";
import contactUsAPI from "../../api/contact-us/api";

export function useCreateContactUs() {
  return useMutation({
    mutationFn: contactUsAPI.createContactUs,
    onError: (error) => {
      console.error("Create contact-us message failed:", error);
    },
  });
}
